export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14028.ba1136c6.jpg";